module.exports = __webpack_public_path__ + "img/icon-mail.62a62edf.svg";